export const NotFound = () => {
  return (
    <div className="flex w-[100vw] h-[100vh] justify-center items-center">
      페이지를 찾을 수 없습니다.
    </div>
  );
};
